const byIdReducer = (current, next) => {
  // eslint-disable-next-line no-param-reassign
  current[next.id] = next;
  return current;
};

export default (state, action) => {
  if (action.status !== 'success') {
    return state;
  }

  const { materials } = action.payload;

  return {
    ...state,
    ...materials.reduce(byIdReducer, {}),
  };
};
